import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../router/all_routes'
import {
  FormValues,
  registerFields,
  schema,
} from '../../../config/fields/register'
import { useMutation } from '@tanstack/react-query'
import { postRegister } from '../../../api/auth'
import { useNotify } from '../../../provider/NotificationProvider'

const Register: React.FC = () => {
  const notify = useNotify()
  const [eye, setEye] = useState<boolean>(true)
  const [eyeConfirmPassword, setEyeConfirmPassword] = useState<boolean>(true)

  const route = all_routes
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(schema) as any,
  })

  const registerMutation = useMutation({
    mutationFn: async (data: FormValues) => {
      return postRegister(data)
    },
    onSuccess: (data) => {
      notify.success({
        message: 'Registrasi berhasil',
        description: 'Akun berhasil dibuat, silakan login.',
      })
      navigate(all_routes.login)
    },
    onError: (err: any) => {
      notify.error({
        message: 'Registrasi gagal',
        description: err?.response?.data?.message || 'Terjadi kesalahan.',
      })
    },
  })

  const onSubmit = (data: FormValues) => {
    registerMutation.mutate(data)
  }

  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper">
        <div className="login-content">
          <div className="row">
            {/* Login Banner */}
            <div className="col-lg-6 login-bg d-none d-lg-flex p-5">
              <div className="login-carousel-section mb-3">
                <div className="login-banner">
                  <ImageWithBasePath
                    src="/assets/img/login.webp"
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div
                  className="mentor-course text-center mt-5"
                  style={{ color: '#1E344C' }}
                >
                  <h3 className="mb-2" style={{ color: '#1E344C' }}>
                    Assalamu’alaikum,
                    <br />
                    <span className="" style={{ color: '#1E344C' }}>
                      Welcome to Jadipraktisi!
                    </span>
                  </h3>
                  <p className="" style={{ color: '#1E344C' }}>
                    Bismillah, perjalanan karirmu akan dimulai dari sini, masuk
                    sekarang!
                  </p>
                </div>
              </div>
            </div>
            {/* /Login Banner */}
            <div className="col-lg-6 login-wrap-bg">
              {/* Login */}
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="w-100">
                    <div className="d-flex align-items-center justify-content-between login-header">
                      <Link to={route.home} className="link-1">
                        <ImageWithBasePath
                          src="/assets/img/logo-color.webp"
                          className="img-fluid"
                          alt="Logo"
                          width={250}
                        />
                      </Link>
                    </div>
                    <h1 className="fs-32 fw-bold topic">Sign up</h1>
                    <form
                      onSubmit={handleSubmit(onSubmit)}
                      className="mb-3 pb-3"
                    >
                      {registerFields.map(([fieldName, config]) => {
                        return (
                          <div className="mb-3" key={fieldName}>
                            <label className="form-label">
                              {config.label}{' '}
                              {config.required && (
                                <span className="text-danger"> *</span>
                              )}
                            </label>
                            <div
                              className={
                                config.type === 'password'
                                  ? 'position-relative'
                                  : ''
                              }
                            >
                              <input
                                {...config}
                                {...register(fieldName)}
                                className="form-control"
                                type={
                                  config.type === 'password'
                                    ? fieldName === 'password'
                                      ? eye
                                        ? 'password'
                                        : 'text'
                                      : eyeConfirmPassword
                                      ? 'password'
                                      : 'text'
                                    : config.type
                                }
                              />
                              {config.type === 'password' && (
                                <span
                                  onClick={() => {
                                    if (fieldName === 'password') setEye(!eye)
                                    else
                                      setEyeConfirmPassword(!eyeConfirmPassword)
                                  }}
                                  style={{
                                    position: 'absolute',
                                    top: '50%',
                                    right: '10px',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {(
                                    fieldName === 'password'
                                      ? eye
                                      : eyeConfirmPassword
                                  ) ? (
                                    <AiOutlineEyeInvisible size={20} />
                                  ) : (
                                    <AiOutlineEye size={20} />
                                  )}
                                </span>
                              )}
                            </div>
                            {errors[fieldName] && (
                              <p className="text-danger">
                                {errors[fieldName]?.message}
                              </p>
                            )}
                          </div>
                        )
                      })}

                      <button
                        type="submit"
                        className="btn btn-secondary btn-lg d-block w-100"
                        disabled={registerMutation.isPending}
                      >
                        {registerMutation.isPending ? 'Loading...' : 'Sign Up'}
                      </button>
                    </form>
                    {/* <div className="d-flex align-items-center justify-content-center or fs-14 mb-3">
                      Or
                    </div> */}
                    {/* <div className="d-flex align-items-center justify-content-center mb-3"> */}
                    {/* <Link to="#" className="btn btn-light me-2">
                        <ImageWithBasePath
                          src="assets/img/icons/google.svg"
                          alt="img"
                          className="me-2"
                        />
                        Google
                      </Link> */}
                    {/* <Link to="#" className="btn btn-light">
                        <ImageWithBasePath
                          src="assets/img/icons/facebook.svg"
                          alt="img"
                          className="me-2"
                        />
                        Facebook
                      </Link> */}
                    {/* </div> */}
                    <div className="fs-14 fw-normal d-flex align-items-center justify-content-center">
                      Already you have an account?
                      <Link to={route.login} className="link-2 ms-1">
                        {' '}
                        Login
                      </Link>
                    </div>
                    {/* /Login */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  )
}

export default Register
